// Turns a "saved version vs. current" API response (script or description history) into
// the shape DiffModal expects. Only null means "nothing saved yet": an empty previous text
// ('') is a real version and is diffed like any other.
export function savedVersionDiff(data) {
  if (data.previous_content === null || data.previous_content === undefined) {
    return { emptyText: 'No previous version saved yet.' };
  }
  return {
    previous: data.previous_content,
    current: data.current_content || '',
    oldLabel: data.previous_created_at
      ? `Saved ${new Date(data.previous_created_at).toLocaleString()}`
      : 'Previous version',
  };
}
